import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Loading from "react-simple-loading";
import "bootstrap-icons/font/bootstrap-icons.css";
import logo from "../../assets/images/logo.png";
import bgImage from '../../assets/images/bg.jpeg';
import "../../styles/auth.css";


const Login = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorResponse, setErrorResponse] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [captchaError, setCaptchaError] = useState(false);
  const [captcha, setCaptcha] = useState({ question: "", answer: null });
  const [userCaptchaInput, setUserCaptchaInput] = useState("");
  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    const email = localStorage.getItem("@user_email");
    const role = localStorage.getItem("@user_role");
    if (email && role === "1") {
      navigate("/admin/dashboard");
    }
    generateCaptcha();
  }, [navigate]);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ question: `${num1} + ${num2}`, answer: num1 + num2 });
    setUserCaptchaInput("");
    setCaptchaError(false);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorResponse(null);
    setCaptchaError(false);
    const { email, password } = inputData;
    if (!email || !password) {
      setIsSubmitting(false);
      return;
    }

    if (parseInt(userCaptchaInput) !== captcha.answer) {
      setCaptchaError(true);
      generateCaptcha(); // reset CAPTCHA on wrong answer
      setIsSubmitting(false);
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/login`,
        { email, password },
        { headers: { "Content-Type": "application/json" }, withCredentials: true }
      );

      setIsSubmitting(false);

      if (data?.status && data?.user?.role) {


        // Define role mapping
        const role_mapping = { 'admin': 1, 'manager': 2, 'assistant_manager': 3, 'overseer': 4, };

        // Normalize role to number
         let user_role ='';

          if (typeof data?.user?.role === "string") {
             user_role =  role_mapping[data?.user?.role] || null; 
            }
          else  {
             user_role = data?.user?.role;
           
          }

          if (user_role) {
            localStorage.setItem("@user_role", user_role);
            localStorage.setItem("@user_email", email);
            localStorage.setItem("@name", data?.user?.name);
            localStorage.setItem("@user_id", data?.user?.id);

            switch (user_role) {
              case 1:
                navigate("/admin/dashboard");
                break;
              case 2:
                navigate("/manager/dashboard");
                break;
              case 3:
                navigate("/assistant-manager/dashboard");
                break;
              case 4:
                navigate("/overseer/dashboard");
                break;
              default:
                navigate("/login"); // fallback
            }




          } else {
            setErrorResponse(data?.message || "Invalid credentials.");
          }
        }
         else {
            setErrorResponse(data?.message || "Invalid credentials.");
          }
      
    } catch (err) {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: err.message,
      });
    }
  };

  return (
    <div className="login-page bg-light" style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '100vh',
    }}>
      <div className="login-box">
        <div className="card card-outline card-primary bg-white-partial">
          <div className="card-header text-center">
            <a href="#" className="link-dark text-center">
              <img src={logo} alt="Logo" />
            </a>
          </div>
          <div className="card-body login-card-body bg-transparent">
            {errorResponse && (
              <div className="alert alert-danger" role="alert">
                {errorResponse}
              </div>
            )}

            <p className="login-box-msg">Sign in to start your session</p>

            <form onSubmit={handleLogin}>
              <div className="input-group mb-1">
                <div className="form-floating flex-grow-1">
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={inputData.email}
                    onChange={(e) => setInputData({ ...inputData, email: e.target.value })}
                    disabled={isSubmitting}
                  />
                  <label htmlFor="email">Email</label>
                </div>
                <span className="input-group-text"><i className="bi bi-envelope"></i></span>
              </div>
              <div className="input-group mb-1">
                <div className="form-floating flex-grow-1">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={inputData.password}
                    onChange={(e) => setInputData({ ...inputData, password: e.target.value })}
                    disabled={isSubmitting}
                  />
                  <label htmlFor="password">Password</label>
                </div>
                <span
                  className="input-group-text"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={`bi ${showPassword ? "bi-eye" : "bi-eye-fill"}`}></i>
                </span>
              </div>

              <div className="form-group mb-3">
                <label className="fw-bold mb-1">
                  Solve to verify: <span className="text-primary">{captcha.question} = ?</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={userCaptchaInput}
                  onChange={(e) => setUserCaptchaInput(e.target.value)}
                  disabled={isSubmitting}
                />
                {captchaError && (
                  <div className="text-danger small mt-1">Incorrect answer. Try again.</div>
                )}
              </div>

              <div className="row my-2">
                <div className="col-8 d-flex align-items-center">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="rememberMe"
                      disabled={isSubmitting}
                    />
                    <label className="form-check-label fw-bold" htmlFor="rememberMe">
                      Remember Me
                    </label>
                  </div>
                </div>

                <div className="col-4">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <Loading /> : "Login"}
                  </button>
                </div>
              </div>
            </form>

            <p className="mb-1">
              <Link className="btn btn-link p-0" to="/forgot-password">
                I forgot my password
              </Link>
            </p>
          </div>
        </div>
      </div>



{/* Footer Links Section */}
      <div className="login-footer-links w-100 text-center position-absolute" style={{ bottom: '1in' }}>
        <div className="d-flex justify-content-center align-items-center gap-2">
          <Link to="https://blessedbuilderssoberliving.org/about-us" className="footer-link" target="_blank">About Us</Link>
          <span className="footer-separator">|</span>
          <Link to="https://blessedbuilderssoberliving.org/contact-us" className="footer-link" target="_blank">Contact Us</Link>
          <span className="footer-separator">|</span>
          <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
          <span className="footer-separator">|</span> 
          <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
        </div>
      </div>

      
    </div>
  );
};

export default Login;
